// extracted by mini-css-extract-plugin
export default {"card":"BooksCard_card__rubb8","description":"BooksCard_description__qVl0q","btn":"BooksCard_btn__388ha","main":"BooksCard_main__hUj40"};